
import SettingsIcon from '~/components/ui/icons/SettingsIcon.vue';
import UIDonutChart from '~/components/ui/organism/UIDonutChart.vue';
import ProfileImg from '~/components/ui/atom/ProfileImg.vue';
import { inAppRedirect } from '~/utils/route-redirects';
import { getSectorLabelKey } from '~/utils/sectors';

export default {
  name: 'PortfolioCardWithDonutChart',
  components: {
    SettingsIcon,
    UIDonutChart,
    ProfileImg,
  },
  props: {
    portfolio: { type: Object, required: true },
    showDonutChart: { type: Boolean, default: true },
    donutChartPerformanceSavingMode: { type: Boolean, default: false },
    showMarketValue: { type: Boolean, default: true },
    showOverallPerformance: { type: Boolean, default: false },
    noBorder: { type: Boolean, default: false },
    noPadding: { type: Boolean, default: false },
    hideHeaderActions: { type: Boolean, default: false },
    showSettingsIcon: { type: Boolean, default: false },
    showOwnerProfileImg: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: true },
    dataType: {
      type: String,
      default: 'items',
      validator: (v) => ['items', 'industries'].includes(v),
    },
  },
  data() {
    return {
      chartData: [],
    };
  },
  computed: {
    hasLeagueRank() {
      return (
        (this.portfolio.socials?.rankInLeague > 0 ||
          this.portfolio.socials.isInPrivateLeague) &&
        this.portfolio.leagueId &&
        this.portfolio.isListed
      );
    },
    isPrivateLeague() {
      return this.portfolio?.socials?.isInPrivateLeague;
    },
    rankSize() {
      return this.isPrivateLeague ? 6 : 10;
    },
    rankFontSize() {
      return this.isPrivateLeague ? 3 : 4;
    },
    chartSize() {
      return this.hideHeaderActions ? 80 : 64;
    },
    displayName() {
      return this.dataType === 'sectors'
        ? this.translateSector(this.name)
        : this.name;
    },
  },
  watch: {
    portfolio: {
      handler(portfolio) {
        this.generateChartData(portfolio);
      },
      immediate: true,
    },
    dataType() {
      this.generateChartData(this.portfolio);
    },
  },
  methods: {
    generateChartData(source) {
      if (!this.showDonutChart || !source?.portfolioView) {
        this.chartData = [];
        return;
      }

      let data = [];
      const view = source.portfolioView;

      if (this.dataType === 'items') {
        if (Array.isArray(view.allocationRepartition)) {
          const mapped = [];
          let cashTotal = 0;

          view.allocationRepartition.forEach((entry) => {
            const value = Number(entry.repartitionPercent?.toFixed(2) || 0);

            // We're grouping all cash entries into one
            if (entry.type === 'Cash') {
              cashTotal += value;
              return;
            }

            mapped.push({
              name: entry.label || entry.code || 'Unknown',
              value,
            });
          });

          if (cashTotal > 0) {
            mapped.push({
              name: this.$t('sectors_cash'),
              value: Number(cashTotal.toFixed(2)),
            });
          }

          data = mapped;
        }
      }

      if (this.dataType === 'industries') {
        if (
          view.industryRepartition &&
          typeof view.industryRepartition === 'object'
        ) {
          data = Object.entries(view.industryRepartition).map(
            ([industry, percent]) => ({
              name: this.translateSectors(industry),
              value: Number(percent?.toFixed(2) || 0),
            })
          );
        }
      }

      this.chartData = data;
    },

    onPortfolioClicked() {
      this.$emit('onPortfolioClicked');
    },
    onSettingsClicked() {
      if (!this.showSettingsIcon) return;
      this.$emit('onSettingsClicked');
    },
    translateSectors(sectorName) {
      return this.$t(getSectorLabelKey(sectorName));
    },
    goToProfile(profileId) {
      inAppRedirect(`/profile/${profileId}`);
    },
  },
};
